const copy = {
  zh: {
    title: '正在打开工作台',
    description: '系统根据账号所属业务打开对应工作台。',
    note: '如业务归属不正确，请联系管理员调整账号。',
    ecommerce: '电商工作台',
    ecommerceDescription: '管理商品、QA 和售后工单，跟进客户补充资料与处理结果。',
    frontDesk: '前台工作台',
    frontDeskDescription: '配置电话接待、联系人与人工转接，处理回电请求和通话记录。',
    loading: '正在确认账号业务…', saving: '正在更新入口…', retry: '重试',
    loadError: '暂时无法读取工作台，请重试。',
    saveError: '入口未更新，请联系管理员。', login: '返回登录',
  },
  en: {
    title: 'Opening your workspace',
    description: 'Your account business determines which workspace opens.',
    note: 'If the business assignment is incorrect, please contact your administrator.',
    ecommerce: 'Ecommerce workspace',
    ecommerceDescription: 'Manage products, Q&A and support tickets, including customer information and resolutions.',
    frontDesk: 'Front desk workspace',
    frontDeskDescription: 'Configure reception, contacts and transfers, and review callback requests and call records.',
    loading: 'Checking your account business…', saving: 'Updating your entry…', retry: 'Retry',
    loadError: 'Your workspace could not be loaded. Please retry.',
    saveError: 'The entry was not updated. Please contact your administrator.', login: 'Back to sign-in',
  },
};
export const workspaceCopy = (lang) => copy[lang === 'zh' ? 'zh' : 'en'];
